export var JoinPath;
(function (JoinPath) {
    JoinPath["UNKNOWN_JOIN_PATH"] = "UNKNOWN_JOIN_PATH";
    /** Member joined to the program for free */
    JoinPath["FREE"] = "FREE";
    /** Member was added to the program by site owner */
    JoinPath["ADDED"] = "ADDED";
    /** Member paid once to join the program */
    JoinPath["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    /** Member has Paid Plan to join */
    JoinPath["PAID_PLAN"] = "PAID_PLAN";
    /** Member joined with the Free Coupon */
    JoinPath["FREE_COUPON"] = "FREE_COUPON";
})(JoinPath || (JoinPath = {}));
export var State;
(function (State) {
    /** Unknown state */
    State["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    /** Member invited to participate in program */
    State["INVITED"] = "INVITED";
    /** Member asked owner to participate in program */
    State["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    State["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    /** Member joined the program and became participant */
    State["JOINED"] = "JOINED";
    /** Participant completed the program, and could join again */
    State["COMPLETED"] = "COMPLETED";
    /** Participant failed to complete the program, and could join again */
    State["FAILED"] = "FAILED";
    /** Participant with ended pricing plan (PP), will be joined as renew PP */
    State["SUSPENDED"] = "SUSPENDED";
})(State || (State = {}));
export var Status;
(function (Status) {
    /** step completed */
    Status["COMPLETED"] = "COMPLETED";
    /** participant failed to resolve step */
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var BenefitType;
(function (BenefitType) {
    /** Should never be used */
    BenefitType["UNDEFINED"] = "UNDEFINED";
    /** Limited benefit type */
    BenefitType["LIMITED"] = "LIMITED";
    /** Unlimited benefit type */
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType || (BenefitType = {}));
export var Event;
(function (Event) {
    Event["Updated"] = "Updated";
    Event["Deleted"] = "Deleted";
    Event["Created"] = "Created";
})(Event || (Event = {}));
//# sourceMappingURL=types.impl.js.map